<div class="cheatsheet-overlay" *ngIf="visible" (click)="onOverlayClick($event)">
  <div class="cheatsheet-card">
    <div class="cheatsheet-header">
      <h3>{{ 'keyboard.title' | translate }}</h3>
      <button class="cheatsheet-close" (click)="close.emit()" aria-label="Close">
        <i class="icon-cross" aria-hidden="true"></i>
      </button>
    </div>
    <div class="cheatsheet-body">
      <div class="cheatsheet-category" *ngFor="let cat of categories">
        <h4>{{ 'keyboard.category_' + cat.name | translate }}</h4>
        <div class="cheatsheet-row" *ngFor="let s of cat.shortcuts">
          <span class="cheatsheet-desc">{{ 'keyboard.' + s.description | translate }}</span>
          <kbd class="cheatsheet-kbd">{{ s.combo }}</kbd>
        </div>
      </div>
    </div>
  </div>
</div>
